import React from 'react'
import { Modal, Placeholder } from '@telegram-apps/telegram-ui'

import { Button } from 'components'

import './styles.scss'

interface Props {
  children: React.ReactNode
  confirmLabel: string
  onSetOpen: (value: boolean) => void
  onActionClick: () => void
  onCancelClick?: () => void
  open?: boolean
  closeOnConfirm?: boolean
  cancelLabel?: string
}

export const ConfirmModal = (props: Props) => {
  const {
    children,
    confirmLabel,
    cancelLabel = 'Отмена',
    closeOnConfirm = true,
    open,
    onSetOpen,
    onActionClick,
    onCancelClick,
  } = props

  const onActionClickHandler = () => {
    onActionClick?.()

    if (closeOnConfirm) {
      onSetOpen(false)
    }
  }

  const onClose = () => {
    onSetOpen(false)
    onCancelClick?.()
  }

  return (
    <Modal
      open={open}
      className="confirm-modal"
      onOpenChange={(state) => onSetOpen(state)}
      dismissible
    >
      <Placeholder>
        <div className="confirm-text">{children}</div>

        <div className="confirm-buttons">
          <Button className="confirm-option cancel-button" onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button className="confirm-option confirm-button" onClick={onActionClickHandler}>
            {confirmLabel}
          </Button>
        </div>
      </Placeholder>
    </Modal>
  )
}
